import { isMobile } from "react-device-detect"
import { IoMdAddCircle } from "react-icons/io"
import { BulletTabs } from "../../components/BulletTabs"
import { Button, ButtonLoader } from "../../components/Button"
import { FileInput } from "../../components/FileInput"
import { Input, Label, SelectInput } from "../../components/Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import "./styles.scss"

const IndividualImport = ({ handleChange, selectedProject, projectOptions, values }) => {
  return (
    <>
      <div className="import_form__content">
        <Label>Nome completo</Label>
        <Input
          placeholder="Digite o nome completo do beneficiário"
          onChange={(e) => handleChange("name", e.target.value)}
        />
      </div>
      {isMobile ? (
        <>
          <div>
            <Label>Telefone</Label>
            <Input
              placeholder="+55 ( ) 0000-0000"
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </div>
          <div className="import_form__content">
            <Label>CPF</Label>
            <Input
              placeholder="999.999.999-99"
              type={"number"}
              onChange={(e) => handleChange("document", e.target.value)}
            />
          </div>
        </>
      ) : (
        <div className="import_form_dual__content">
          <div>
            <Label>Telefone</Label>
            <Input
              placeholder="+55 ( ) 0000-0000"
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </div>
          <div>
            <Label>CPF</Label>
            <Input
              placeholder="999.999.999-99"
              type={"number"}
              onChange={(e) => handleChange("document", e.target.value)}
            />
          </div>
        </div>
      )}
      <div className="import_form__content">
        <Label>Email *</Label>
        <Input
          placeholder="Digite o email do beneficiário"
          onChange={(e) => handleChange("email", e.target.value)}
        />
      </div>
      <div className="import_form__content">
        <Label>E qual projeto você quer cadastrar esse beneficiário?</Label>
        <SelectInput
          handleChange={(e) => handleChange("project", e)}
          isClearable={false}
          isSearchable
          options={projectOptions}
          value={selectedProject}
        />
      </div>
    </>
  )
}

const GroupImport = ({
  handleGetFileModel,
  loading,
  selectedProject,
  projectOptions,
  handleChange,
  values,
}) => {
  return (
    <>
      <div className="group_import_form__content">
        <Button
          variant="ghost"
          label="Baixar modelo do arquivo"
          handleClick={handleGetFileModel}
          isDisabled={loading}
        />
      </div>
      <div className="group_import_form__content">
        <FileInput
          value={values?.file}
          handleChangeFile={(fileLink) => handleChange("file", fileLink)}
        />
      </div>

      <div className="import_form__content">
        <Label>E qual projeto você quer cadastrar esses beneficiários?</Label>
        <SelectInput
          handleChange={(e) => handleChange("project", e)}
          isClearable={false}
          isSearchable
          options={projectOptions}
          value={selectedProject}
        />
      </div>
    </>
  )
}

export const FarmerImportScreen = ({
  isModalOpen,
  tab,
  handleOpenModal,
  handleCloseModal,
  handleChangeTab,
  handleGetFileModel,
  loading,
  selectedProject,
  projectOptions,
  handleChange,
  handleSaveUser,
  handleUploadFile,
  values,
}) => {
  return (
    <>
      {isMobile ? (
        <div>
          <IoMdAddCircle className="add-button" onClick={handleOpenModal} />
          <ModalPanel modalIsOpen={isModalOpen}>
            <div className="form-header">
              <div style={{ display: "flex", gap: "10px" }} onClick={handleCloseModal}>
                <button className="button-back">
                  <i className="fi fi-sr-arrow-small-left" />
                </button>
                <div className="title">Adicionar beneficiário(a)</div>
              </div>
            </div>
            <ModalBody className="import_content_modal">
              <div className="user_import__container">
                <BulletTabs
                  options={[
                    { value: 1, label: "Individual" },
                    { value: 2, label: "Importação" },
                  ]}
                  onSelect={(value) => handleChangeTab(value)}
                />
                {tab === 1 ? (
                  <IndividualImport
                    selectedProject={selectedProject}
                    projectOptions={projectOptions}
                    handleChange={handleChange}
                  />
                ) : (
                  <GroupImport
                    values={values}
                    handleGetFileModel={handleGetFileModel}
                    loading={loading}
                    selectedProject={selectedProject}
                    projectOptions={projectOptions}
                    handleChange={handleChange}
                  />
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="user_import__footer">
                <ButtonLoader
                  label="Salvar informações"
                  handleClick={tab === 1 ? handleSaveUser : handleUploadFile}
                  color="green"
                  // loading={saving}
                  className={"button-green"}
                  messageProcess="Enviando Conteúdo"
                />
              </div>
            </ModalFooter>
          </ModalPanel>
        </div>
      ) : (
        <div className="famer_import__container">
          <Button label="Adicionar beneficiário" variant="outline" handleClick={handleOpenModal} />
          <ModalPanel modalIsOpen={isModalOpen}>
            <ModalHeader closeModal={handleCloseModal}>
              <span className="header__titlte">Adicionar beneficiário</span>
            </ModalHeader>
            <ModalBody className="import_content_modal">
              <div className="user_import__container">
                <BulletTabs
                  options={[
                    { value: 1, label: "Individual" },
                    { value: 2, label: "Importação" },
                  ]}
                  onSelect={(value) => handleChangeTab(value)}
                />
                {tab === 1 ? (
                  <IndividualImport
                    selectedProject={selectedProject}
                    projectOptions={projectOptions}
                    handleChange={handleChange}
                    values={values}
                  />
                ) : (
                  <GroupImport
                    handleGetFileModel={handleGetFileModel}
                    loading={loading}
                    selectedProject={selectedProject}
                    projectOptions={projectOptions}
                    handleChange={handleChange}
                    values={values}
                  />
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="user_import__footer">
                <Button
                  label="Salvar informações"
                  classButton="button-save-mobile-form"
                  handleClick={tab === 1 ? handleSaveUser : handleUploadFile}
                  isDisabled={tab === 1 && !values['email']}
                />
              </div>
            </ModalFooter>
          </ModalPanel>
        </div>
      )}
    </>
  )
}
